import { ExporttocsvService, csvDate, csvCurrency } from '../../services/exporttocsv/exporttocsv.service';
import {Component, Input, OnChanges, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Dictionary} from 'highcharts';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'app-reconciliation-teamlog',
    templateUrl: './reconciliation-teamlog.component.html',
    styleUrls: ['./reconciliation-teamlog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReconciliationTeamlogComponent implements OnInit, OnChanges {

  @Input() info: any;
  columnsToDisplay = ['date', 'email', 'team', 'sender', 'message', 'amount', 'taxable', 'status'];
  public items = new MatTableDataSource<Dictionary<any>>();
  public form: UntypedFormGroup;


  exportCsv(title: string): void {
    this.csvExport.exportTable(title, this.items, {
      "date": {header: "Transaction Date", value: (item: any) => csvDate(item.createdAt, 'mediumDate')},
      "email": {header: "Recipient", value: (item: any) => item.email},
      "team": {header: "Team", value: (item: any) => item.teamName},
      "sender": {header: "Sender", value: (item: any) => item.sender},
      "message": {header: "Message", value: (item: any) => item.message},
      "amount": {header: "Amount", value: (item: any) => csvCurrency(item.transactionAmount)},
      "taxable": {header: "Taxable", value: (item: any) => item.taxable},
      "status": {header: "Status", value: (item: any) => item.status},
    }, this.columnsToDisplay, {exclude: ['action', 'actionmenu']});
  }

  constructor(
      private formBuilder: UntypedFormBuilder,
      private csvExport: ExporttocsvService
  ) {
    this.form = this.formBuilder.group({
    });
  }

  ngOnInit(): void {
    this.loadItems();
  }

  ngOnChanges(): void {
    this.loadItems();
  }

  private loadItems(): void {
    this.items.data = this.info.teamLogTransactions;
    this.items.data?.forEach(item => {
      const thisMember = this.info.members.find((member: any) => member.id === item.senderUserId);
      item.sender = (thisMember?.firstName || '') + ' ' + (thisMember?.lastName || '');
    });
  }

}
